import { gtmSendEvent } from "@wojo/analytics";
import { useI18n } from "@wojo/localization";
import { Collapsible, Markdown, Text } from "@wojo/ui";
import { forwardRef, useId } from "react";
import { TourEquipmentContent } from "../../../generated/graphql";
import styles from "./EquipmentModalInfo.module.scss";

type EquipmentModalInfoProps = {
    tourEquipment?: TourEquipmentContent;
};

export const EquipmentModalInfo = forwardRef<
    HTMLDivElement,
    EquipmentModalInfoProps
>(({ tourEquipment }, ref) => {
    const { productPage } = useI18n("productPage");
    const titleId = useId();

    return (
        <section ref={ref} className={styles.info} aria-labelledby={titleId}>
            <Text.Heading
                tag="h2"
                order="4"
                id={titleId}
                style={{ marginBottom: "var(--g-spacing-xxs)" }}
            >
                {tourEquipment?.name}
            </Text.Heading>
            <Text.Body
                style={{
                    fontStyle: "italic",
                    marginBottom: "var(--g-spacing-xxs)",
                }}
            >
                {tourEquipment?.detailedName}
            </Text.Body>
            <Text.Body style={{ marginBottom: "var(--g-spacing-lg)" }}>
                {tourEquipment?.price}
            </Text.Body>
            {!!tourEquipment?.description && (
                <Markdown
                    style={{ marginBottom: "var(--g-spacing-lg)" }}
                    markdown={tourEquipment.description}
                />
            )}
            {tourEquipment?.specs && (
                <Collapsible
                    title={productPage.equipment.detailsLabel.l()}
                    hidePadding
                    className={styles.collapsible}
                    onToggle={(isExpanded) => {
                        gtmSendEvent({
                            event: "track",
                            ga4Tracking: {
                                ga4_object: "EQUIPMENT_MODAL",
                                ga4_action: isExpanded
                                    ? "SPECS_EXPANDED"
                                    : "SPECS_COLLAPSED",
                                modalId: "Equipment Modal",
                            },
                        });
                    }}
                >
                    <Markdown
                        style={{
                            marginBottom: "var(--g-spacing-lg)",
                            marginTop: "var(--g-spacing-lg)",
                        }}
                        markdown={tourEquipment.specs}
                    />
                </Collapsible>
            )}
        </section>
    );
});

EquipmentModalInfo.displayName = "EquipmentModalInfo";
